export type FilterMenuActionKey = 'CONDITIONS' | 'BRANDS' | 'COLORS' | 'MATERIALS' | 'CATEGORIES';

export const FILTER_MENU_ACTION: Record<FilterMenuActionKey, any> = {
  CONDITIONS: {
    INIT_SET: 'filterMenu/CONDITIONS/INIT_SET',
    SELECTION_PARSED_FROM_URL_PARAMS: 'filterMenu/CONDITIONS/SELECTION_PARSED_FROM_URL_PARAMS',
  },
  BRANDS: {
    INIT_SET: 'filterMenu/BRANDS/INIT_SET',
    SELECTION_PARSED_FROM_URL_PARAMS: 'filterMenu/BRANDS/SELECTION_PARSED_FROM_URL_PARAMS',
  },
  COLORS: {
    INIT_SET: 'filterMenu/COLORS/INIT_SET',
    SELECTION_PARSED_FROM_URL_PARAMS: 'filterMenu/COLORS/SELECTION_PARSED_FROM_URL_PARAMS',
  },
  MATERIALS: {
    INIT_SET: 'filterMenu/MATERIALS/INIT_SET',
    SELECTION_PARSED_FROM_URL_PARAMS: 'filterMenu/MATERIALS/SELECTION_PARSED_FROM_URL_PARAMS',
  },
  CATEGORIES: {
    INIT_SET: 'filterMenu/CATEGORIES/INIT_SET',
    SELECTION_PARSED_FROM_URL_PARAMS: 'filterMenu/CATEGORIES/SELECTION_PARSED_FROM_URL_PARAMS',
  },
};
